import FormValidator from './FormValidator.vue'
import InputDatePicker from './InputDatePicker.vue'
import InputErrorText from './InputErrorText.vue'
import InputText from './InputText.vue'
import InputTextarea from './InputTextarea.vue'

export default {
    'tl-form-validator': FormValidator,
    'tl-input-datepicker': InputDatePicker,
    'tl-input-error-text': InputErrorText,
    'tl-input-text': InputText,
    'tl-input-textarea': InputTextarea,
}
